var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _path, _path2, _path3, _rect349, _rect350, _rect351;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCodeKioskDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1155px",
    height: "1155px",
    viewBox: "0 0 1155 1155",
    enableBackground: "new 0 0 1155 1155",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1155,
    height: 1155,
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,70)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,0) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,35) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,70) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,105) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,140) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,175) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,210) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,245) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,280) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,315) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,350) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,385) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,420) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,455) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,490) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,525) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(245,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,560) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,595) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,630) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(175,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,665) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(105,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(210,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,700) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,735) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,770) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,805) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,840) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,875) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(350,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(455,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(525,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(595,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(630,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(945,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,910) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(490,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(875,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(910,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(980,945) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(420,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(665,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(700,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(735,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(805,980) scale(0.35,0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0) scale(2.45, 2.45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    style: {
      fill: "none"
    },
    width: 70,
    height: 70
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(770,0) scale(2.45, 2.45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    style: {
      fill: "none"
    },
    width: 70,
    height: 70
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,770) scale(2.45, 2.45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    style: {
      fill: "none"
    },
    width: 70,
    height: 70
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,70) scale(1.05, 1.05)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,70) scale(1.05, 1.05)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70,840) scale(1.05, 1.05)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeKioskDownload);
export default __webpack_public_path__ + "static/media/qr-code-kiosk-download.6c93c5043a6080c79d47690dbe932539.svg";
export { ForwardRef as ReactComponent };